
export const CHECK_AUTH0_INFO_REQUEST = '@AuthProvider/CHECK_AUTH0_INFO_REQUEST';
export const CHECK_AUTH0_INFO_SUCCESS = '@AuthProvider/CHECK_AUTH0_INFO_SUCCESS';
export const CHECK_AUTH0_INFO_FAILED = '@AuthProvider/CHECK_AUTH0_INFO_FAILED';

export const LOGOUT_REQUEST = '@AuthProvider/LOGOUT_REQUEST';
export const LOGOUT_SUCCESS = '@AuthProvider/LOGOUT_SUCCESS';
export const LOGOUT_FAILED = '@AuthProvider/LOGOUT_FAILED';
